/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import ContractAnalysisList from 'components/organisms/contract_analysis_list';
import { useDispatch } from 'react-redux';
import { list_contract_analysis } from 'store/modules/contract_analysis/actions';
import HelpVideoModal from 'components/molecules/help_video_modal';
import createTrack from 'services/actions/tracker_actions';
import AmbassadorToolFeedback from 'components/molecules/ambassador_tool_feedback';
import { CONTRACT_CLAUSES_AMBASSADOR_SLUG } from 'services/ambassador_tools';

const ContractValidator = () => {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [statusFilters, setStatusFilters] = useState<string[]>([]);
  const [search, setSearch] = useState<string>('');
  const [modalVideoOpened, setModalVideoOpened] = useState<boolean>(false);

  useEffect(() => {
    document.title = 'Análise de Cláusulas Contratuais - ConLicitação';
    dispatch(list_contract_analysis(currentPage, statusFilters, search));
  }, [currentPage, statusFilters, search]);

  const toggleStatusFilter = (status: string) => {
    setStatusFilters((prev) =>
      prev.includes(status) ? prev.filter((s) => s !== status) : [...prev, status],
    );
  };

  const FilterBadge = ({
    label,
    checked,
    onChange,
  }: {
    label: string;
    checked: boolean;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  }) => {
    return (
      <div className="form-check mr-3 d-flex align-items-center">
        <input
          className="form-check-input mr-2"
          type="checkbox"
          checked={checked}
          onChange={onChange}
          style={{ marginTop: 0 }}
        />

        <label className="mb-0 d-flex align-items-center">{label}</label>
      </div>
    );
  };

  return (
    <div className="page-container">
      <div className="container-fluid big-resolutions">
        <div className="row mb-4 px-md-4 pt-4">
          <div className="col-md-12 mb-3">
            <div className="d-flex justify-content-between align-items-start">
              <div>
                <div className="d-md-flex d-block align-items-center">
                  <h4 className="mb-1 mr-3">Análise de Cláusulas Contratuais</h4>
                  <button
                    type="button"
                    className="btn btn-link p-0 btn-sm d-flex align-items-center"
                    onClick={() => {
                      setModalVideoOpened(true);
                      createTrack('Clicou no botão video tutorial', {
                        fonte: 'Análise de contrato',
                      });
                    }}
                  >
                    <i className="material-icons mr-1">videocam</i>
                    Veja como funciona
                  </button>
                </div>

                <p>
                  Ferramenta para validar a conformidade entre a minuta de contrato presente no
                  edital e o contrato recebido da Administração Pública.
                </p>
              </div>
              <Link
                to="/validar_contrato/criar"
                className="btn btn-primary d-flex align-items-center"
              >
                <i className="material-icons align-middle">add</i>
                Nova Análise
              </Link>
            </div>
          </div>
        </div>
        <div className="row px-md-4 pb-4">
          <div className="col-md-12">
            <div className="d-flex align-items-center flex-wrap">
              <div className="input-group mr-3" style={{ maxWidth: 350 }}>
                <input
                  type="text"
                  className="form-control"
                  style={{ borderColor: '#DFDFDF' }}
                  placeholder="Buscar um contrato/edital"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />

                <div className="input-group-append">
                  <button
                    type="button"
                    className="btn btn-link bg-white border border-left-0"
                    style={{ borderColor: '#DFDFDF' }}
                    onClick={() => setSearch('')}
                  >
                    Limpar
                  </button>
                </div>
              </div>
              <FilterBadge
                label="Concluído"
                checked={statusFilters.includes('completed')}
                onChange={() => toggleStatusFilter('completed')}
              />

              <FilterBadge
                label="Processando"
                checked={statusFilters.includes('pending')}
                onChange={() => toggleStatusFilter('pending')}
              />
            </div>
          </div>
        </div>
        <ContractAnalysisList currentPage={currentPage} setCurrentPage={setCurrentPage} />
      </div>
      <HelpVideoModal
        modalVideoOpened={modalVideoOpened}
        setModalVideoOpened={setModalVideoOpened}
        urlVideo="https://player.vimeo.com/video/1148631963"
      />
      <AmbassadorToolFeedback toolSlug={CONTRACT_CLAUSES_AMBASSADOR_SLUG} />
    </div>
  );
};
export default ContractValidator;
